import { BottomViewFlyers, HeaderFixed, StickyHeader } from '@/components';
import { FlyerType } from '@/config/constants';
import { BodyLargeEmphasized, ContentSwitcher, FlyerboardHeader } from '@/design-system';
import { Flyer } from '@/graphql/types';
import { Subscription } from '@/types/subscriptions';
import styles from './Upcoming.styles';
import { Calendar } from './components/Calendar/Calendar';

interface UpcomingProps {
  trackId: string;
  flyerType: string;
  selectedAudienceId: string;
  stickyHeaderHeight: number;
  stickyTop: number;
  flyers: Array<Flyer>;
  subscriptions: Subscription[];
  onTabChangeFlyerType: (newFlyerType: string) => void;
  handleClickFlyerType: () => void;
  onStickyTopChanged: (stickyTop: number) => void;
}

export const Upcoming: React.FC<UpcomingProps> = ({
  trackId,
  flyerType,
  stickyHeaderHeight,
  stickyTop,
  flyers,
  subscriptions,
  selectedAudienceId,
  onTabChangeFlyerType,
  handleClickFlyerType,
  onStickyTopChanged,
}) => (
  <>
    <div className={styles.header}>
      <h4 data-testid="pageTitle">
        <BodyLargeEmphasized>Upcoming</BodyLargeEmphasized>
      </h4>
    </div>
    <HeaderFixed>
      <ContentSwitcher
        trackId={trackId}
        options={[
          {
            label: 'School',
            value: FlyerType.school,
          },
          {
            label: 'Community',
            value: FlyerType.community,
          },
        ]}
        onChange={onTabChangeFlyerType}
        selected={flyerType}
      />
      <FlyerboardHeader
        selectedAudienceId={selectedAudienceId}
        subscriptions={subscriptions}
        type={flyerType}
        trackingEventFrom=""
      />
    </HeaderFixed>
    <div className={styles.container}>
      <StickyHeader
        stickyHeaderHeight={stickyHeaderHeight}
        onStickyTopChanged={onStickyTopChanged}
      />
      <Calendar trackId={trackId} stickyTop={stickyTop} flyers={flyers} />
    </div>
    <BottomViewFlyers
      label={`View Upcoming ${FlyerType.school === flyerType ? 'Community' : 'School'} Flyers`}
      onClick={handleClickFlyerType}
      variant={FlyerType[flyerType]}
    />
  </>
);
